export const VehicleType = {
    Unknown: 'Unknown',
    PassengerVehicle: 'PassengerVehicle',
    CommercialVehicle: 'CommercialVehicle',
    CommercialVehicleWithHitch: 'CommercialVehicleWithHitch',
    Trailer: 'Trailer',
    SemiTrailer: 'SemiTrailer',
    AutonomousTrailer: 'AutonomousTrailer',
    MiddleAxisTrailer: 'MiddleAxisTrailer',
    MotorCycle: 'MotorCycle',
    MotorCycleWithSidecar: 'MotorCycleWithSidecar',
    ThreeWheeledMotorCarrier: 'ThreeWheeledMotorCarrier',
    LightDisabledCar: 'LightDisabledCar',
    ThreeWheeler: 'ThreeWheeler',
    Moped: 'Moped',
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];

export const VehicleTypeOptions = [
    {
        label: 'core.vehicle_type.trailer',
        value: VehicleType.Trailer
    },
    {
        label: 'core.vehicle_type.passenger_vehicle',
        value: VehicleType.PassengerVehicle
    },
    {
        label: 'core.vehicle_type.moped',
        value: VehicleType.Moped
    },
    {
        label: 'core.vehicle_type.motorcycle',
        value: VehicleType.MotorCycle
    },
    {
        label: 'core.vehicle_type.commercial_vehicle',
        value: VehicleType.CommercialVehicle
    },
    {
        label: 'core.vehicle_type.commercial_vehicle_with_hitch',
        value: VehicleType.CommercialVehicleWithHitch
    },
    {
        label: 'core.vehicle_type.autonomous_trailer',
        value: VehicleType.AutonomousTrailer
    },
    {
        label: 'core.vehicle_type.semi_trailer',
        value: VehicleType.SemiTrailer
    },
    {
        label: 'core.vehicle_type.middle_axis_trailer',
        value: VehicleType.MiddleAxisTrailer
    },
    {
        label: 'core.vehicle_type.motorcycle_with_sidecar',
        value: VehicleType.MotorCycleWithSidecar
    },
    {
        label: 'core.vehicle_type.three_wheeled_motor_carrier',
        value: VehicleType.ThreeWheeledMotorCarrier
    },
    {
        label: 'core.vehicle_type.light_disabled_car',
        value: VehicleType.LightDisabledCar
    },
    {
        label: 'core.vehicle_type.three_wheeler',
        value: VehicleType.ThreeWheeler
    }
]
